import { backend } from "../../../../../xconvert-backend";
import { authentication } from "../../../../../authentication";

export interface AiParseResult {
    _id: string;
    rawInput?: string;
    input?: string;
    output?: string;
    rawOutput?: string;
    type?: string;
    tokensConsumed?: number;
    model?: string;
    promptTokens?: number;
    completionTokens?: number;
    totalPrice?: number;
    actuallyUsedModel?: string;
    counter?: number;
}

export interface TestSettings {
    fieldsToIgnore?: string[];
    fieldsToFuzzyMatch?: Record<string, number>;
}

export interface TestFailureLogEntry {
    _id?: string;
    testName: string;
    errorMessage?: string;
    expected?: string;
    actual?: string;
    diffs: string[];
    detailedDiffSummary?: string;
    testSettings?: TestSettings;
    timestamp: string;
    expectedAiProcessingData?: AiParseResult[];
    actualAiProcessingData?: AiParseResult[];
}

export interface FetchTestFailuresResponse {
    total: number;
    testFailures: TestFailureLogEntry[];
}

export async function fetchTestFailures(params: {
    testName?: string;
    errorContains?: string;
    limit?: number;
}): Promise<FetchTestFailuresResponse> {
    const auth = await backend.withTokenAuthHeader(authentication.token);

    const requestHeaders: Record<string, string> = {
        "Content-Type": "application/json; charset=utf-8",
    };
    Object.assign(requestHeaders, auth.headers);

    const body: any = {
        limit: params.limit || 100
    };

    if (params.testName !== undefined && params.testName !== null) {
        body.testName = params.testName;
    }

    if (params.errorContains !== undefined && params.errorContains !== null) {
        body.errorContains = params.errorContains;
    }

    const response = await fetch('/api/internal/getTestFailures', {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(errorBody || `Server error (${response.status})`);
    }

    return response.json();
}